import template from './filter-map-form.html.twig';

const { Component, Mixin } = Shopware;

Component.register('topdata-es-filter-map-form', {
    template,

    mixins: [
        Mixin.getByName('notification'),
    ],

    props: {
        entity: {
            type: Object,
            required: true,
        },
        repository: {
            type: Object,
            required: true,
        },
    },

    data() {
        return {
            isLoading: false,
        };
    },

    computed: {
        isNew() {
            return this.entity.isNew();
        },

        modalTitle() {
            return this.isNew
                ? this.$tc('TopdataEnhancedSearchSW6.topdata-es-filter-map.modalTitleAdd')
                : this.$tc('TopdataEnhancedSearchSW6.topdata-es-filter-map.modalTitleEdit');
        },
    },

    methods: {
        onSave() {
            if (!this.entity.searchTerm.trim() || !this.entity.blockedTerm.trim()) {
                return;
            }

            this.entity.salesChannelId = null;

            this.isLoading = true;
            this.repository.save(this.entity).then(() => {
                this.createNotificationSuccess({
                    message: this.$tc('TopdataEnhancedSearchSW6.topdata-es-filter-map.saveSuccess'),
                });
                this.$emit('save', this.entity);
            }).catch(() => {
                this.isLoading = false;
            });
        },

        onCancel() {
            this.$emit('cancel');
        },
    },
});